import {AttendeeDetails} from "../../domain/attendee-details.entity";
import {AttendeeAnalytics} from "../../domain/attendee-analytics.entity";

/**
 * V2 mapper for AttendeeDetails.
 * Wraps inline AttendeeAnalytics data as AttendeeDetails with rich fields unset.
 *
 * V2 has no per-attendee details endpoint. The modal receives the inline row
 * data from the attendees list and converts it to AttendeeDetails.
 *
 * Pure TypeScript - no React imports.
 */
export class AttendeeDetailsMapperV2 {
  /**
   * Maps inline AttendeeAnalytics entity to AttendeeDetails.
   * Rich fields (bookingQuestions, totalPurchases, totalVolume) remain unset.
   */
  static fromInlineAttendee(attendee: AttendeeAnalytics): AttendeeDetails {
    return AttendeeDetails.create({
      firstName: attendee.firstName,
      lastName: attendee.lastName,
      emailAddress: attendee.emailAddress,
      amount: attendee.amount,
      currency: attendee.currency,
      reference: attendee.reference,
      createdAt: attendee.createdAt,
    });
  }
}
